"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCompat = checkCompat;
exports.performanceNowAvailable = performanceNowAvailable;

var _runtime = _interopRequireDefault(require("../utils/runtime"));

var _index = _interopRequireDefault(require("../logger/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBrowser() {
  return typeof window !== 'undefined';
}

function checkCompat(env) {
  if (isBrowser() && window.navigator.cookieEnabled && window.MutationObserver && window.performance && window.performance.timing && window.performance.navigation && window.performance.getEntriesByType && window.localStorage && window.requestAnimationFrame) {
    return true;
  } else if (isBrowser()) {
    var runtimeEnv = env || _runtime.default.get('env');

    if (runtimeEnv !== 'prod') {
      _index.default.error('[performance-collect]: 设备不支持性能工具');
    }

    return false;
  }

  return false;
}

function performanceNowAvailable() {
  return !!performance.now;
}